import * as React from 'react';
import SyndicateService from '../service/SyndicateService';
const SyndicateContext = React.createContext(new SyndicateService());
export default SyndicateContext;
